import type { CountryCode } from "@brand/model";

type Link = { text: string, to: string }
type Description = { text: string, links?: Link[] };

export enum SCROLL_DIRECTION {
  toPrevious = -1,
  toNext = 1,
  toStart = 0,
}

export type LevelCardData = {
  id: string,
  title: string,
  subtitle: string,
  descriptions: Description[],
  misc: string,
}

export type LevelsInfoPayload = {
  countryCode: CountryCode,
  controller?: AbortController
  isArchivedLevels?: boolean,
}